import axios from "axios";

const apiClient = axios.create({
  withCredentials: false,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    "pragma": "no-cache",
    "cache-control": "no-cache"
  }
});
export default {
  getRegions() {
    return apiClient.get(`${window.currentStep}/regionfilters`);
  },
  getNumbers(prefix) {
    return apiClient.get(`${window.currentStep}/getnumbers?prefix=${prefix}`);
  },
  getNumberStatus() {
    return apiClient.get(`${window.currentStep}/getnumberstate`);
  },
  reserveDivert(utm) {
    return apiClient.post(`${window.currentStep}/reservedivert`, JSON.stringify(utm));
  },
  getNextUrl(utm) {
    return apiClient.post(`${window.currentStep}/getnexturl`, JSON.stringify(utm));
  },
  chooseNumber(number, utm) {
    var formattedNumber = JSON.stringify(number.replace(/\s/g, ""));
    return apiClient.post(`${window.currentStep}/choosenumber/${formattedNumber}`, JSON.stringify(utm));
  },
  reserveNumber(number, receipt) {
    var formattedNumber = JSON.stringify(number.replace(/\s/g, ""));
    return apiClient.get(`${window.currentStep}/reserve/${formattedNumber}/${receipt}`);
  },
  unReserveNumber(number, receipt) {
    var formattedNumber = JSON.stringify(number.replace(/\s/g, ""));
    return apiClient.get(`${window.currentStep}/unreserve/${formattedNumber}/${receipt}`);
  },
  getBasket(receipt) {
    return apiClient.get(`${window.currentStep}/basket/${receipt}`);
  },
  finaliseCleverNumbers(routes, utm, receipt) {
    return apiClient.post(`${window.currentStep}/Finalise`, {
      "receipt": receipt,
      "routes": routes,
      "utmData": utm
    });
  }
};
